import React from "react";
import { Icon, Button } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import moment from "moment";

import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

export default class Rating extends React.Component {
  state = {
    isLoadingFeedback: false
  };
  renderTile() {
    const { commentCount, positiveRatingCount, negativeRatingCount, fetchFeedback, userRating } = this.props;

    return (
      <OverlayTrigger
        placement="top"
        trigger={["click"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top" title={"Dataset Feedback"}>
            <div className={styles.tileOverlay}>{this.renderTileOverlay()}</div>
          </Popover>
        }
      >
        <div
          className={styles.ratingWrapper}
          onClick={() => {
            this.setState({ isLoadingFeedback: true });
            fetchFeedback().then(() => {
              this.setState({ isLoadingFeedback: false });
            });
          }}
        >
          <div className={styles.commentWrapper + " " + styles.isTile}>
            <span style={{ marginLeft: "2px" }}>{commentCount + " comment" + (commentCount !== 1 ? "s" : "")}</span>
          </div>
          <div
            className={styles.smallRating + " " + styles.noClick + " " + styles.activeLike}
            style={{ padding: "4px 5px", marginRight: "4px" }}
          >
            <Icon size={13} type={"thumbsUpWhite"} />
            <span>{positiveRatingCount}</span>
          </div>
          <div
            className={styles.smallRating + " " + styles.noClick + " " + styles.activeDislike}
            style={{ padding: "4px 5px", marginRight: "4px" }}
          >
            <Icon size={13} type={"thumbsDown"} />
            <span>{negativeRatingCount}</span>
          </div>
        </div>
      </OverlayTrigger>
    );
  }

  renderTileOverlay() {
    const {
      id,

      isSmall,
      isTile,

      userId,
      commentCount,
      comments,
      positiveRatingCount,
      negativeRatingCount,
      positiveRatings,
      negativeRatings,
      userRating,
      tags,
      addTag,
      deleteTag,

      toggleDatasetRating,
      postComment,
      deleteComment,

      hideTags
    } = this.props;

    const isLoading = this.state.isLoadingFeedback;

    if (isLoading) {
      return <LoadingIndicator style={{ margin: "0px auto", minHeight: "80px" }} />;
    }

    return (
      <div className={styles.feedbackWrapper + " " + styles.isOverlay}>
        <div className={styles.feedbackSection + " " + styles.isOverlay}>
          <div className={styles.feedbackRatingWrapper}>
            <div className={styles.feedbackRating + " " + styles.isOverlay}>
              <RatingItem
                type={"LIKE"}
                isUser={userRating === "LIKE"}
                onClick={() => toggleDatasetRating("LIKE")}
                count={positiveRatingCount}
                hideType
              />
              {positiveRatings &&
                positiveRatings.map((rating) => (
                  <div
                    key={"rating" + rating.id}
                    className={styles.feedbackRatingUser}
                    title={rating && rating.created_by ? rating.created_by.fullname : ""}
                  >
                    {rating && rating.created_by ? rating.created_by.fullname : ""}
                  </div>
                ))}
            </div>
            <div className={styles.feedbackRating}>
              <RatingItem
                type={"DISLIKE"}
                isUser={userRating === "DISLIKE"}
                onClick={() => toggleDatasetRating("DISLIKE")}
                count={negativeRatingCount}
                hideType
              />
              {negativeRatings &&
                negativeRatings.map((rating) => (
                  <div
                    key={"rating" + rating.id}
                    className={styles.feedbackRatingUser}
                    title={rating && rating.created_by ? rating.created_by.fullname : ""}
                  >
                    {rating && rating.created_by ? rating.created_by.fullname : ""}
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className={styles.feedbackSection + " " + styles.isOverlay}>
          <div className={styles.feedbackTitle}>{"Comments"}</div>
          <div className={styles.feedbackComments}>
            {comments &&
              comments.map((comment) => (
                <CommentItem
                  key={"comment" + comment.id}
                  comment={comment}
                  deleteComment={() => deleteComment(comment.id)}
                  isCreator={comment.created_by && comment.created_by.id === userId}
                />
              ))}
          </div>
          <AddComment postComment={postComment} />
        </div>
      </div>
    );
  }

  renderSmall() {
    const {
      noClick,

      commentCount,
      positiveRatingCount,
      negativeRatingCount,
      userRating,
      tags,

      toggleDatasetRating,
      openPanel,

      hideTags
    } = this.props;

    return (
      <div className={styles.ratingWrapper}>
        <div
          className={styles.commentWrapper + " " + (noClick ? styles.noClick : "")}
          onClick={noClick ? undefined : openPanel}
        >
          <Icon size={16} type={"comment"} />
          <span>{commentCount + " comment" + (commentCount !== 1 ? "s" : "")}</span>
        </div>
        <div
          className={
            styles.smallRating +
            " " +
            (noClick ? styles.noClick : "") +
            " " +
            (userRating === "LIKE" ? styles.activeLike : "")
          }
          onClick={noClick ? undefined : () => toggleDatasetRating("LIKE")}
        >
          <Icon size={16} type={userRating === "LIKE" ? "thumbsUpWhite" : "thumbsUpPurple"} />
          <span>{positiveRatingCount}</span>
        </div>
        <div
          className={
            styles.smallRating +
            " " +
            (noClick ? styles.noClick : "") +
            " " +
            (userRating === "DISLIKE" ? styles.activeDislike : "")
          }
          onClick={noClick ? undefined : () => toggleDatasetRating("DISLIKE")}
        >
          <Icon size={16} type={userRating === "DISLIKE" ? "thumbsDown" : "thumbsDownPurple"} />
          <span>{negativeRatingCount}</span>
        </div>
        {!hideTags && (
          <div
            className={styles.smallTags + " " + (noClick ? styles.noClick : "")}
            onClick={noClick ? undefined : openPanel}
          >
            <Icon size={16} type={"tag"} />
            <div className={styles.smallTagHolder}>
              {tags && tags.length ? (
                tags.map((tag, i, tagsArr) =>
                  i === tagsArr.length - 1 && tagsArr.length > 6 ? (
                    <TagItem
                      key={"tag " + (tag ? tag.name : i)}
                      tag={{ name: tagsArr.length - 5 + " other tags" }}
                      noOverlay
                    />
                  ) : i < 5 || tagsArr.length === 6 ? (
                    <TagItem key={"tag " + (tag ? tag.name : i)} tag={tag} noOverlay />
                  ) : (
                    ""
                  )
                )
              ) : (
                <TagItem tag={{ name: "0 tags" }} noOverlay />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      isSmall,
      isTile,
      isLoading,

      userId,
      commentCount,
      comments,
      positiveRatingCount,
      negativeRatingCount,
      positiveRatings,
      negativeRatings,
      userRating,
      tags,
      addTag,
      deleteTag,

      toggleDatasetRating,
      postComment,
      deleteComment,

      hideTags
    } = this.props;

    if (isSmall) {
      return this.renderSmall();
    }

    if (isTile) {
      return this.renderTile();
    }

    // Small and Tile mode both shouldn't have the loading indicator
    if (isLoading) {
      return <LoadingIndicator style={{ margin: "0px auto", minHeight: "80px" }} />;
    }

    return (
      <div className={styles.feedbackWrapper}>
        {!hideTags && (
          <div className={styles.feedbackSection}>
            <div className={styles.feedbackTitle}>{"Tags"}</div>
            <div className={styles.feedbackTagsWrapper}>
              {tags &&
                tags.map((tag, i) => (
                  <TagItem
                    key={"tag " + (tag ? tag.name : i)}
                    tag={tag}
                    handleDelete={() => deleteTag(tag && tag.name)}
                    isCreator={tag && tag.created_by && tag.created_by.id === userId}
                    style={{ marginBottom: "6px" }}
                  />
                ))}
            </div>
            <AddTag addTag={addTag} />
          </div>
        )}
        <div className={styles.feedbackSection}>
          <div className={styles.feedbackRatingWrapper}>
            <div className={styles.feedbackRating}>
              <RatingItem
                type={"LIKE"}
                isUser={userRating === "LIKE"}
                onClick={() => toggleDatasetRating("LIKE")}
                count={positiveRatingCount}
              />
              {positiveRatings &&
                positiveRatings.map((rating) => (
                  <div
                    key={"rating" + rating.id}
                    className={styles.feedbackRatingUser}
                    title={rating && rating.created_by ? rating.created_by.fullname : ""}
                  >
                    {rating && rating.created_by ? rating.created_by.fullname : ""}
                  </div>
                ))}
            </div>
            <div className={styles.feedbackRating}>
              <RatingItem
                type={"DISLIKE"}
                isUser={userRating === "DISLIKE"}
                onClick={() => toggleDatasetRating("DISLIKE")}
                count={negativeRatingCount}
              />
              {negativeRatings &&
                negativeRatings.map((rating) => (
                  <div
                    key={"rating" + rating.id}
                    className={styles.feedbackRatingUser}
                    title={rating && rating.created_by ? rating.created_by.fullname : ""}
                  >
                    {rating && rating.created_by ? rating.created_by.fullname : ""}
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className={styles.feedbackSection}>
          <div className={styles.feedbackTitle}>{"Comments"}</div>
          <div className={styles.feedbackComments}>
            {comments &&
              comments.map((comment) => (
                <CommentItem
                  key={"comment" + comment.id}
                  comment={comment}
                  deleteComment={() => deleteComment(comment.id)}
                  isCreator={comment.created_by && comment.created_by.id === userId}
                />
              ))}
          </div>
          <AddComment postComment={postComment} />
        </div>
      </div>
    );
  }
}

class TagItem extends React.PureComponent {
  render() {
    const { isCreator, noClick, handleDelete, tag, noOverlay, className, ...retProps } = this.props;
    return (
      <OverlayTrigger
        placement="top"
        trigger={noClick || noOverlay ? [] : ["click"]}
        rootClose
        overlay={
          <Popover id="popover-positioned-top" title={tag && tag.name}>
            <div className={styles.commentItemWrapper} style={{ marginBottom: "0px" }}>
              {/* <div className={styles.commentMessage}>{tag && tag.name}</div> */}
              <div className={styles.commentAuthor}>{tag && tag.created_by ? tag.created_by.fullname : ""}</div>
              <div className={styles.commentTime}>
                {moment
                  .utc(tag && tag.updated_date)
                  .local()
                  .format("MMMM Do YYYY, h:mm:ss a")}
              </div>
              <div className={styles.tagActions}>{isCreator ? <a onClick={handleDelete}>Delete</a> : ""}</div>
            </div>
          </Popover>
        }
      >
        <div
          className={styles.tagItemWrapper + " " + (noClick ? styles.noClick : "") + " " + (className ? className : "")}
          {...retProps}
        >
          {tag && tag.name}
        </div>
      </OverlayTrigger>
    );
  }
}

class RatingItem extends React.PureComponent {
  render() {
    const { type, onClick, count, isUser, hideType } = this.props;
    let icon, rClass;
    if (type === "LIKE") {
      if (isUser) {
        icon = "thumbsUpWhite";
        rClass = styles.likeActive;
      } else {
        icon = "thumbsUpPurple";
        rClass = styles.like;
      }
    } else if (type === "DISLIKE") {
      if (isUser) {
        icon = "thumbsDown";
        rClass = styles.dislikeActive;
      } else {
        icon = "thumbsDownPurple";
        rClass = styles.dislike;
      }
    }
    return (
      <div
        className={styles.ratingItemWrapper + " " + rClass + " " + (hideType ? styles.shrink : "")}
        onClick={onClick}
      >
        <Icon type={icon} size={13} />
        {hideType ? (
          <span style={{ paddingLeft: "6px" }} />
        ) : (
          <span className={styles.ratingItemText + " " + rClass}>{type}</span>
        )}
        <span className={styles.ratingItemCount + " " + rClass}>{count}</span>
      </div>
    );
  }
}

class CommentItem extends React.PureComponent {
  render() {
    const { comment, deleteComment, isCreator } = this.props;

    return (
      <div className={styles.commentItemWrapper}>
        <div className={styles.commentMessage}>{comment.message}</div>
        <div className={styles.commentAuthor}>{comment.created_by ? comment.created_by.fullname : ""}</div>
        <div className={styles.commentTime}>
          {moment.utc(comment.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")}
        </div>
        <div className={styles.commentActions}>{isCreator ? <a onClick={deleteComment}>Delete</a> : ""}</div>
      </div>
    );
  }
}

class AddTag extends React.Component {
  state = { isEdit: false, tagName: "" };
  handleClose() {
    this.setState({ isEdit: false, tagName: "" });
  }
  handleOpen() {
    this.setState({ isEdit: true });
  }
  render() {
    const { addTag } = this.props;
    const { isEdit, tagName } = this.state;
    return (
      <div className={styles.addTagWrapper}>
        <div className={styles.addCommentLink}>
          <Icon type={"tagPurple"} size={13} />
          <a onClick={() => (isEdit ? this.handleClose() : this.handleOpen())}>{"Add Tag"}</a>
        </div>
        <div className={styles.addTagEdit + " " + (!isEdit ? styles.hide : "")}>
          <textarea
            className={styles.addCommentInput}
            placeholder={"Enter Tag Name"}
            value={tagName}
            onChange={(e) => this.setState({ tagName: e.target.value })}
            rows={1}
          />
          <div className={styles.addCommentButtons}>
            <Button type={"secondary"} onClick={() => this.handleClose()}>
              {"Cancel"}
            </Button>
            <Button
              style={{ marginLeft: "auto" }}
              type={"primary"}
              onClick={() => {
                this.handleClose();
                return addTag(tagName);
              }}
            >
              {"Add Tag"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

class AddComment extends React.Component {
  state = { isEdit: false, commentText: "" };
  handleClose() {
    this.setState({ isEdit: false, commentText: "" });
  }
  handleOpen() {
    this.setState({ isEdit: true });
  }
  render() {
    const { postComment, isTileOverlay, id } = this.props;
    const { isEdit, commentText } = this.state;
    return (
      <div className={styles.addCommentWrapper + " " + (!isTileOverlay ? styles.isOverlay : "")}>
        <div className={styles.addCommentLink}>
          <Icon type={"chatPurple"} size={13} />
          <a onClick={() => (isEdit ? this.handleClose() : this.handleOpen())}>{"Add Comment"}</a>
        </div>
        <div
          className={
            styles.addCommentEdit + " " + (!isTileOverlay ? styles.isOverlay : "") + " " + (!isEdit ? styles.hide : "")
          }
        >
          <textarea
            className={styles.addCommentInput}
            placeholder={"Enter Comment"}
            value={commentText}
            onChange={(e) => this.setState({ commentText: e.target.value })}
            rows={3}
          />
          <div className={styles.addCommentButtons}>
            <Button type={"secondary"} onClick={() => this.handleClose()}>
              {"Cancel"}
            </Button>
            <Button
              style={{ marginLeft: "auto" }}
              type={"primary"}
              onClick={() => {
                this.handleClose();
                return postComment(commentText);
              }}
            >
              {"Add Comment"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
